import type { StaticField } from '@tribeplatform/react-components/Views'

export const getStaticFieldById = (staticFields: StaticField[], id: string) => {
  return staticFields.find(field => field.id === id)
}
